import React, { useCallback, useContext, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import useToast from "store/customHooks/useToast";
import "react-toastify/dist/ReactToastify.css";
import styled, { css } from "styled-components";
import { AppContext } from "App";

/*
 * Toast Message 컴포넌트
 * - isShow : 토스트 메세지 노출 여부
 * - msg : 토스트 메세지 내용
 */

function ToastMessage() {
    const appContext = useContext(AppContext);
    const { toastState, closeToast, updateToast } = useToast();

    const CustromToast = () => {
        return (
            <div className="toast-message">
                {toastState.toastImg && (
                    <div className="toast-message__icon">
                        <img src={toastState.toastImg} alt="토스트 이미지" />
                    </div>
                )}

                <div className="toast-message__text" dangerouslySetInnerHTML={{ __html: toastState.msg }}></div>
            </div>
        );
    };

    const handleToastClose = useCallback(() => {
        closeToast();
    }, [closeToast]);

    useEffect(() => {
        // console.log("toastState : ", toastState);

        if (toastState.isShow && toastState.toastId) {
            toast["info"](<CustromToast />, {
                toastId: toastState.toastId,
                onClose: handleToastClose,
                autoClose: 3000, //  꺼지는데 걸리는 시간
                closeOnClick: true, // 클릭으로 토스트 제거
                limit: 1, // 토스트 갯수 제한
            });

            updateToast({ toastId: null }); // 라우터 변경 시, 중복호출 방지용도
        }
    }, [toastState, handleToastClose, updateToast]);

    return (
        <Container
            isShow={toastState.isShow}
            position="bottom-center"
            autoClose={3000} //  꺼지는데 걸리는 시간
            hideProgressBar
            newestOnTop
        />
    );
}

export const Container = styled(ToastContainer)`
    ${({ isShow }) => {
        return css`
            .Toastify__toast {
                width: max-content;
                padding: 0 !important;

                font-size: 16px;
                border-radius: 50px;
                color: #fff;
                background: rgba(107, 115, 135, 0.8);

                display: ${isShow ? "block" : "none"};
            }

            .Toastify__toast-icon {
                width: 22px;
                height: 22px;
            }

            .Toastify__toast--info {
                background: rgba(119, 119, 119, 0.96);
            }

            .Toastify__toast--success {
                background: rgba(48, 173, 120, 0.8);
            }

            .Toastify__toast--error {
                background: rgba(224, 72, 82, 0.8);
            }

            .toast-message {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 24px 64px;

                &__icon {
                    display: inline-block;
                    width: 22px;
                    height: 22px;
                    margin-right: 10px;

                    > img {
                        width: 100%;
                        height: 100%;
                    }
                }

                &__text {
                    color: #fff;
                    text-align: center;
                    font-family: NanumSquareRoundOTFB;
                    font-size: 18px;
                    font-weight: 700;
                    line-height: 26px;
                    white-space: nowrap;
                }
            }
        `;
    }}
`;

export default ToastMessage;
